module.exports = __webpack_public_path__ + "r-v3/img/userCount_gray.82d19588.svg";